module.exports = __webpack_public_path__ + "static/media/cool-guy.0f068631.png";